'use client';

import { ReactNode, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';

import { analyticsEnabled, setAnalyticsUser, startAnalytics } from '@/lib/analytics';
import { getAuthInstance } from '@/lib/firebase';

// Stripe Elementsは各ページで個別に初期化するため、ここでは削除
// チェックアウトページなど、必要なページでElementsを使用する
export function Providers({ children }: { children: ReactNode }) {
  // GA4 を 1 度だけ起動する。流入元は GA4 が page_view と一緒に自動で取るため、
  // ここを通しておかないと「どこから来た人が買ったか」が全く残らない。
  useEffect(() => {
    if (!analyticsEnabled()) return;
    void startAnalytics();
    // 匿名で見ていた人が会員になったら同じ人として繋ぐ。ログアウトでは外す。
    let unsubscribe: (() => void) | undefined;
    try {
      unsubscribe = onAuthStateChanged(getAuthInstance(), (user) => {
        setAnalyticsUser(user ? user.uid : null);
      });
    } catch {
      // Auth が初期化されていない環境では計測だけ諦める。
    }
    return () => unsubscribe?.();
  }, []);

  return <>{children}</>;
}
